import { useSelector } from "react-redux";
import {
    WORKFLOW_STEPS,
    getStepGroup,
    getSubStepTitle,
    isStepCodeVisibleForUserType,
} from "../../constants/workflowStepCodes";
import { useStepLabels } from "../../context/StepLabelsContext";
import "./StepCodeTag.css";

export default function StepCodeTag({ code, size = "sm", showTitle = false }) {
    const { stepLabelsVisible } = useStepLabels();
    const userType = useSelector((state) => state.user.currentUser?.type);
    const step = WORKFLOW_STEPS[code];
    const group = getStepGroup(code);
    const title = step?.title || getSubStepTitle(code) || code;

    if (
        !group ||
        !stepLabelsVisible ||
        !isStepCodeVisibleForUserType(code, userType)
    ) {
        return null;
    }

    return (
        <span
            className={`step-code-tag step-code-tag--${size}`}
            style={{
                color: group.color,
                backgroundColor: group.bgColor,
                borderColor: group.borderColor,
            }}
            title={title}
        >
            {code}
            {showTitle && title && (
                <span className="step-code-tag__title">{title}</span>
            )}
        </span>
    );
}
